import { defineStore } from 'pinia'
import cities2 from '@/utilities/cities.json'
const initialState2 = {
  cities: [...cities2],
  cities2: [...cities2],
  start: '',
  end: '',
  country: '',
  countryCode: '',
  destination: '',
  providerName: {},
  paxes: [],
}
export default defineStore('search', {
  state: () => initialState2,
  actions: {
    jumping(payload) {
      const {
        start = '',
        end = '',
        country = '',
        countryCode = '',
        destination = {},
        providerName = '',
        paxes = [],
      } = payload

      this.start = start
      this.end = end
      this.country = country
      this.countryCode = countryCode
      this.destination = destination
      this.providerName = providerName
      this.paxes = paxes
    }
  },
  persist: true
})
